import { useEffect } from 'react';
import { SignIn, SignUp, useAuth } from '@clerk/clerk-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import Landing        from './pages/Landing';
import Onboarding     from './pages/Onboarding';
import Processing     from './pages/Processing';
import Results        from './pages/Results';
import About          from './pages/About';
import Pricing        from './pages/Pricing';
import History        from './pages/History';
import Contact        from './pages/Contact';
import Terms          from './pages/Terms';
import Privacy        from './pages/Privacy';
import ProtectedRoute from './components/ProtectedRoute';


function AuthPage({ children }) {
  return (
    <div style={{
      background: '#0A0F1E',
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {children}
    </div>
  );
}

// Separate component to handle referral logic inside BrowserRouter
function ReferralHandler() {
  const { isSignedIn, getToken } = useAuth();

  useEffect(() => {
    // Capture referral code from URL
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      sessionStorage.setItem('referralCode', ref);
    }
  }, []);

  useEffect(() => {
    async function registerReferral() {
      const code = sessionStorage.getItem('referralCode');
      if (!isSignedIn || !code) return;
      try {
        const token = await getToken();
        await axios.post(
          process.env.REACT_APP_API_URL + '/api/referral/register',
          { referralCode: code },
          { headers: { Authorization: 'Bearer ' + token } }
        );
        sessionStorage.removeItem('referralCode');
        console.log('Referral registered:', code);
      } catch (err) {
        console.log('Referral registration failed:', err.message);
      }
    }
    registerReferral();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ReferralHandler />
      <Routes>
        <Route path="/"           element={<Landing />} />
        <Route path="/sign-in/*"  element={
          <AuthPage>
            <SignIn routing="path" path="/sign-in" fallbackRedirectUrl="/history" signUpUrl="/sign-up" />
          </AuthPage>
        } />
        <Route path="/sign-up/*"  element={
          <AuthPage>
            <SignUp routing="path" path="/sign-up" fallbackRedirectUrl="/analyze" signInUrl="/sign-in" />
          </AuthPage>
        } />
        <Route path="/analyze"    element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
        <Route path="/processing" element={<ProtectedRoute><Processing /></ProtectedRoute>} />
        <Route path="/results"    element={<ProtectedRoute><Results /></ProtectedRoute>} />
        <Route path="/history"    element={<ProtectedRoute><History /></ProtectedRoute>} />
        <Route path="/pricing"    element={<Pricing />} />
        <Route path="/about"      element={<About />} />
        <Route path="/terms"      element={<Terms />} />
        <Route path="/privacy"    element={<Privacy />} />
        <Route path="/contact"    element={<Contact />} />

      </Routes>
    </BrowserRouter>
  );
}